module.exports = {
      id: "download-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#download",
      toString: function () {
        return this.url;
      }
    }